<template>
    <v-select
        v-model="groupOffersBy"
        :label="$t('group_by')"
        :items="items"
        class="px-3"
        density="compact"
        variant="underlined"
        :hide-details="hideDetails"
        @update:model-value="$emit('group-selected', $event)"
    >
        <template v-slot:item="{item, props}">
            <v-list-item v-bind="props">
                <template v-slot:title>
                    {{ $t(`${tokenBase}.${item.raw}`) }}
                </template>
            </v-list-item>
        </template>
        <template v-slot:selection="{item}">
            <div class="text-caption">
                {{ $t(`${tokenBase}.${item.raw}`) }}
            </div>
        </template>
    </v-select>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class GroupOffersSelect extends Vue {
        @Prop({required: true}) items
        @Prop({required: true}) productStore
        @Prop({default: false, type: Boolean}) hideDetails
        @Prop({default: 'groupBy'}) tokenBase

        get groupOffersBy() {
            return this.productStore.groupOffersBy
        }

        set groupOffersBy(val) {
            this.productStore.SET_GROUP_OFFERS_BY(val)
        }
    }

    export default GroupOffersSelect
</script>

<style scoped lang="scss">
    :deep(.v-select__selections),
    :deep(.v-list-item--link) {
        font-size: 13px;
    }
</style>
